/**
 * DeckSummaryCard - Quick deck summary metrics
 *
 * Displays key metrics at a glance: total cards, lands, avg CMC.
 */
import type { ReactElement } from 'react';

import type { DeckStatistics } from '../../lib/deckStatistics';

export interface DeckSummaryCardProps {
  stats: DeckStatistics;
}

export default function DeckSummaryCard({ stats }: DeckSummaryCardProps): ReactElement {
  return (
    <div className="space-y-3">
      {/* Main metrics row */}
      <div className="grid grid-cols-2 gap-2">
        <div className="rounded-lg bg-zinc-800/50 px-3 py-2 text-center">
          <div className="text-pearl text-xl font-bold">{stats.totalCards}</div>
          <div className="text-ash text-xs">Total Cards</div>
        </div>
        <div className="rounded-lg bg-zinc-800/50 px-3 py-2 text-center">
          <div className="text-pearl text-xl font-bold">{stats.landCount}</div>
          <div className="text-ash text-xs">Lands</div>
        </div>
      </div>

      {/* Secondary metrics row */}
      <div className="grid grid-cols-3 gap-2">
        <div className="rounded-lg bg-zinc-800/30 px-2 py-1.5 text-center">
          <div className="text-silver text-sm font-semibold">{stats.manaCurve.average.toFixed(1)}</div>
          <div className="text-ash text-[10px]">Avg CMC</div>
        </div>
        <div className="rounded-lg bg-zinc-800/30 px-2 py-1.5 text-center">
          <div className="text-silver text-sm font-semibold">{stats.manaCurve.median.toFixed(1)}</div>
          <div className="text-ash text-[10px]">Med CMC</div>
        </div>
        <div className="rounded-lg bg-zinc-800/30 px-2 py-1.5 text-center">
          <div className="text-silver text-sm font-semibold">{stats.uniqueCards}</div>
          <div className="text-ash text-[10px]">Unique</div>
        </div>
      </div>
    </div>
  );
}
